import React, { PropsWithChildren } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import { IQuestion } from '../FaqMenu/FaqMenu';
import { cleanInternalLinkUrl } from '../../utils/cob-utils';
import './FaqTopic.css';
import { Button, Row, Col, Container } from '../../importCL';

interface IFaqTopicProps extends MappedComponentProperties {
    faqQuestion?: IQuestion;
    titleTag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
    backLink?: string;
}

export const FaqTopicEditConfig = {
    emptyLabel: 'FAQ Topic',
    isEmpty: (props: PropsWithChildren<IFaqTopicProps>) => {
        return !props || !props.faqQuestion;
    },
};

const FaqTopic = (props: PropsWithChildren<IFaqTopicProps>) => {
    return (
        <Container id='faq-topic' className='FaqTopic flex pt-16 px-4 pb-14 md:pt-16 md:px-3 md:pb-0 flex-nowrap flex-row md-flex-column md:gap-0'>
            <Row className='px-0 pb-8 md:pb-0'>
                <Col md={9}>
                    <props.titleTag className='pb-4 text-black'>{props.faqQuestion?.question}</props.titleTag>
                    <div className='pb-4'>
                        {props.faqQuestion?.answer && transformHTMLParserLinks(props.faqQuestion.answer)}
                    </div>
                    <a className='no-underline'
                        href={`${cleanInternalLinkUrl(props.backLink ?? '')}`} >
                        <Button className='pl-0' icon='back' size='medium' variant='link'>
                            Back to FAQ
                        </Button>
                    </a>
                </Col>
                <hr className='FaqTopic__hr w-full mx-4 pt-20' />
            </Row>
        </Container>
    );
};

export default FaqTopic;